import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { format, subDays, setHours, setMinutes, setSeconds } from 'date-fns';

import { Report } from '~/components';
import { DateTime, Autocomplete, Input, RadioGroup } from '~/components/Form';

import { GFO } from '~/constants/perfil';

import * as Yup from 'yup';
import { t, parseDateString } from '~/helpers';

function Relextratoproduto() {
  const [open, setOpen] = useState(true);

  //NOVOS CAMPOS
  const [valueOrgao, setValueOrgao] = React.useState('');
  const [inputValueOrgao, setInputValueOrgao] = React.useState('');

  // mantem nome
  const [nomeOrgao, setNomeOrgao] = React.useState('');

  const [valueProduto, setValueProduto] = React.useState('');
  const [inputValueProduto, setInputValueProduto] = React.useState('');

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const { profile } = useSelector((state) => state.user);

  const [disableOrgao, setDisableOrgao] = useState(false);

  async function handleValidate(param) {
    try {
      const schema = Yup.object().shape({
        // datahorainicial:Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        // datahorafinal:Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        datahorainicial: Yup.date()
        .typeError(t('s.geral.validacao.campoobrigatorio'))
        .transform((_, value) => parseDateString(value))
        .required(t('s.geral.validacao.campoobrigatorio')),
      datahorafinal: Yup.date()
        .typeError(t('s.geral.validacao.campoobrigatorio'))
        .transform((_, value) => parseDateString(value))
        .required(t('s.geral.validacao.campoobrigatorio'))
        .max(
          datahorafinal,
          `A data não pode ser superior a ${datahorafinal}`
        )
        .min(
          Yup.ref('datahorainicial'),
          'A data não pode ser inferior a Data inicial'
        ),

        orga_codigo: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .nullable(),
        prod_codigo: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .nullable(),
      });

      await schema.validate(param, {
        abortEarly: false,
      });
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      }
    }
  }

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (profile.glousuariotipo === GFO) {
        setValueOrgao(profile.glousuarioorgacodigo);
        setNomeOrgao(profile.glousuarioorganome);
        setDisableOrgao(true);
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [profile]);

  function handleSerializeForm(params) {
    const { datahorainicial, datahorafinal } = params;

    let orgao = '';
    if (params.orga_codigo) {
      orgao = params.orga_codigo;
    } else {
      orgao = '';
    }

    let orgaostr = '';
    if (params.orga_nome) {
      orgaostr = params.orga_nome;
    } else {
      orgaostr = '';
    }

    // verifica quando carrega automatico
    if (nomeOrgao != '') {
      orgaostr = nomeOrgao;
    }

    let produto = '';
    if (params.prod_codigo) {
      produto = params.prod_codigo;
    } else {
      produto = '';
    }

    let produtostr = '';
    if (params.prod_descricao) {
      produtostr = params.prod_descricao;
    } else {
      produtostr = '';
    }

    // deixa campo(s) apenas para compor o filtro
    let posto = '';
    let postostr = '';

    let tipo = 'pdf';
    if (params.formato) {
      tipo = params.formato;
    } else {
      tipo = 'pdf';
    }

    return {
      ...params,
      datahorainicial,
      datahorafinal,
      produto,
      produtostr,
      orgao,
      orgaostr,
      posto,
      postostr,
      tipo,
    };
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title="Extrato de Produto"
      relatorio="EXTRATOPRODUTO"
      validate={(param) => handleValidate(param)}
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        datahorainicial,
        datahorafinal,
        orga_codigo: valueOrgao,
      }}
    >

      {/* <DateTime time label="Data Inicial" name="datahorainicial" />
      <DateTime time label="Data Final" name="datahorafinal" />  */}

<DateTime
        time
        label="Data Inicial"
        name="datahorainicial"
        disableFuture
      />

      <DateTime
        time
        label="Data Final"
        name="datahorafinal"
        disableFuture
        invalidDateMessage={''}
        minDateMessage={''}
        maxDateMessage={''}
      />

      <Autocomplete
        name="prod_codigo"
        label="prod_descricao"
        title="Produto"
        id="prod_codigo"
        url="produtos"
        unique="prod_codigo"
        value={valueProduto}
        inputValue={inputValueProduto}
        onChange={(event, newValue) => {
          setValueProduto(newValue);
        }}
        onInputChange={(event, newInputValueProtudo) => {
          setInputValueProduto(newInputValueProtudo);
        }}
        defaultValue=""
        hiddens={[{ name: 'prod_descricao' }]}
        getValue={(value) => {
          if (value.prod_codigo !== null) {
            setValueProduto(value.prod_codigo);
          } else {
            setValueProduto('');
          }
        }}
      />

      <Autocomplete
        name="orga_codigo"
        label="orga_nome"
        title="Órgão"
        id="orga_codigo"
        url="orgaos"
        unique="orga_codigo"
        value={valueOrgao}
        inputValue={inputValueOrgao}
        onChange={(event, newValue) => {
          setValueOrgao(newValue);
        }}
        onInputChange={(event, newInputValueOrgao) => {
          setInputValueOrgao(newInputValueOrgao);
        }}
        defaultValue=""
        hiddens={[{ name: 'orga_nome' }]}
        getValue={(value) => {
          if (value.orga_codigo !== null) {
            setValueOrgao(value.orga_codigo);
          } else {
            setValueOrgao('');
          }
        }}
        disabled={disableOrgao}
      />

      <RadioGroup
        name="formato"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Relextratoproduto;
